/* eslint-disable react-hooks/exhaustive-deps */
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import { addLifeCycleStatus } from "../../../../components/CommonTimeLineCard";
import InternalTxnDetailPagePopup from "../../../../components/InternalTransactionMain/InternalTxnDetailPopup/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import CommonTransactionApprovalCard from "../../../../components/_utils/CommonTransactionApprovalCard/index.jsx";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount.js";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent/index.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import {
  addInternalTxnLabel,
  removeInternalTxnLabel,
} from "../../../../redux/features/InternalAccount/internalAccount.js";
import { beneCategories } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";
import { beneInternalViewAllAcc } from "../../../../redux/features/internalApi/internalApi.js";
import { internalTxnAccountDetail } from "../../../../redux/features/internalTransaction/internalTransactionDetailPage.js";
import { internalTxnViewAll } from "../../../../redux/features/internalTransaction/internalTransactionViewAll.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  getOwnerAccBalance,
  ownerListViewAllAcc,
  setshowsuccestoast,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider.js";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat.js";
import "./index.css";

const RefactoredInternalTxnDashboard = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isDashboradCheck, startDateLocationState, endDateLocationState } =
    location.state || {};

  // useRef
  const mobileCheckingDivRef = useRef(null);
  const filterRef = useRef(null);
  const scrollRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const getDefaultWeekSpan = () => {
    const today = dayjs();
    const weekAgo = today.subtract(6, "days");
    return [weekAgo.toDate(), today.toDate()];
  };

  //useState
  const [dropdownOptions, setDropdownOptions] = useState([50, 100]);
  const [selectedValue, setSelectedValue] = useState(50);
  const [storedPage, setStoredPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [mainData, setMainData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [showRefactorPrompt, setShowRefactorPrompt] = useState(false);
  const [allScheduleTxnAccountsLoading, setAllScheduleTxnAccountsLoading] =
    useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [pageSize, setPageSize] = useState(
    window.innerWidth >= 3840 ? 192 : window.innerWidth >= 2560 ? 102 : 50,
  );
  const [currentStatus, setCurrentStatus] = useState("all");
  const [startDateFilter, setStartDateFilter] = useState(
    startDateLocationState ?? "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    endDateLocationState ?? "",
  );

  const [isPaymentMethod, setIsPaymentMethod] = useState("");
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountNo: "",
    bankAccountIFSC: "",
    ownerAccountId: "",
    amount: "",
    ownerbankAccountNo: "",
  });
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [hideCarousal, setHideCaroursal] = useState(false);
  const [beneAccountId, setBeneAccountId] = useState(
    txnPayLoad?.beneAccountId ? txnPayLoad?.beneAccountId : null,
  );
  const [refreshAnimation, setrefreshAnimation] = useState("");
  const [PrevBalance, setPrevBalance] = useState(null);
  const [refactorId, setRefactorId] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(true);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [timelineLoading, setTimelineLoading] = useState(false);

  const [startDate, setStartDate] = useState(() => {
    if (startDateLocationState) return new Date(startDateLocationState * 1000);
    return getDefaultWeekSpan()[0];
  });
  const [endDate, setEndDate] = useState(() => {
    if (endDateLocationState) return new Date(endDateLocationState * 1000);
    return getDefaultWeekSpan()[1];
  });
  const [paymentMethod, setPaymentMethod] = useState("");

  const [accountNumber, setAccountNumber] = useState(
    txnPayLoad?.bankAccountNo ? txnPayLoad?.bankAccountNo : "",
  );
  const [accountName, setAccountName] = useState(
    txnPayLoad?.bankAccountName ? txnPayLoad?.bankAccountName : "",
  );
  const [txnAddDetails, setTxnAddDetails] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showRefactorDetailPop, setShowRefactorDetailPop] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [selectedBeneAccId, setSelectedBeneAccId] = useState(
    props?.bene_account_id ? props?.bene_account_id : "",
  );
  const [selectedOwnerAccId, setSelectedOwnerAccId] = useState(
    props?.Owner_account_id ? props?.Owner_account_id : "",
  );
  const [isConfidentialMethod, setIsConfidentialMethod] = useState(
    props?.bene_account_confidential === "Y"
      ? "Show only confidential"
      : props?.bene_account_confidential === "N"
        ? "Hide confidential"
        : (props?.bene_account_confidential ?? ""),
  );
  const [confidentialMethod, setConfidentialMethod] = useState(
    props?.bene_account_confidential === "Y"
      ? "Show only confidential"
      : props?.bene_account_confidential === "N"
        ? "Hide confidential"
        : (props?.bene_account_confidential ?? ""),
  );
  const [OpenTimeLinePopup, setOpenTimelinePopup] = useState(false);
  const [txnId, setTxnId] = useState(null);
  const [txnAmount, setTxnAmount] = useState("");
  const [txnSearchType, setTxnSearchType] = useState("");
  const [accountNameValue, setAccountNameValue] = useState("");
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);

  const [labelsFilter, setFilterLabels] = useState([]);
  const [searchUserText, setSearchUserText] = useState("");
  const [labelTxnId, setLabelTxnId] = useState([]);
  const [labels, setLabels] = useState([]);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);
  const [timelineTxnDetails, setTimelineTxnDetails] = useState([]);
  const [timelineTxnId, setTimelineTxnId] = useState(null);
  // const [realTimelineState, setRealTimelineState] = useState(null);

  const services = useSelector((state) => state.refreshToken.services);
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const getWeekSpan = () => {
    const currentDate = dayjs(Date.now());
    const weekAgo = currentDate.subtract(6, "days");

    return [weekAgo.toDate(), currentDate.toDate()];
  };

  const isMobile = () => {
    try {
      return (
        getComputedStyle(
          mobileCheckingDivRef.current,
        ).backgroundColor.toString() !== "rgb(0, 0, 0)"
      );
    } catch {
      // Intentionally left blank
    }
  };

  const handleAction = async () => {
    try {
      setAllScheduleTxnAccountsLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_item_count: pageSize,
        lifecycle_status: "rejected",
        refactor: false,
      };

      const addParamsBasedOnSelection = () => {
        if (currentCategory && currentCategory !== "Select category") {
          queryParams.category = currentCategory;
        }
        if (
          startDate &&
          endDate &&
          !isNaN(Number(startDate)) &&
          !isNaN(Number(endDate))
        ) {
          queryParams.start_date = Math.floor(startDate.getTime() / 1000);
          queryParams.end_date = Math.floor(endDate.getTime() / 1000);
        }
        if (labelsFilter?.length && labelsFilter !== "Select labels") {
          queryParams.labels = labelsFilter;
        }
        if (isPaymentMethod) {
          queryParams.payment_method = isPaymentMethod;
        }
        if (isConfidentialMethod) {
          queryParams.confidential_transaction = isConfidentialMethod;
        }

        if (txnSearchType === "additional") {
          if (txnAddDetails !== "") {
            queryParams.category_value = txnAddDetails;
            queryParams.category_name = "value";
          }
        }

        if (txnAmountFilter !== "") {
          queryParams.amount = txnAmountFilter;
        }
        if (selectedBeneAccId !== "") {
          queryParams.internal_account_id = selectedBeneAccId;
        }
        if (selectedOwnerAccId !== "") {
          queryParams.owner_account_id = selectedOwnerAccId;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(internalTxnViewAll(queryParams));
      const newData = response?.payload?.transactions || [];

      setMainData(response?.payload);
      setAccumulatedData(newData);

      setTotalCount(response?.payload?.total_count || 0);
    } catch (error) {
      setMainData([]);
      setAccumulatedData([]);
    } finally {
      setAllScheduleTxnAccountsLoading(false);
    }
  };

  const formatName = (name) => {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const openRefactorTxnDetailModal = (txnId) => {
    setRefactorId(txnId);
    setShowRefactorDetailPop(true);
  };

  const closeRefactorTxnDetailModal = () => {
    setShowRefactorDetailPop(false);
  };

  const closeTimelineModal = () => {
    setOpenTimelinePopup(false);
  };

  const hasAnyFilter =
    Boolean(currentCategory?.length) ||
    Boolean(labelsFilter?.length) ||
    Boolean(accountNumber?.length) ||
    Boolean(searchUserText?.length) ||
    (startDateFilter !== "" &&
      endDateFilter !== "" &&
      startDateFilter !== GlobalConfiguration.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter))) ||
    Boolean(searchUserTextDebounce?.length);

  const noTransactionsFromAPI =
    !allScheduleTxnAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allScheduleTxnAccountsLoading &&
    accumulatedData?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const openTimelineModal = async (txnId) => {
    setTimelineTxnDetails([]); // clear stale data
    setTimelineTxnId(txnId);
    setOpenTimelinePopup(true);
    setTimelineLoading(true);

    const res = await dispatch(internalTxnAccountDetail(txnId));

    if (res?.payload?.transaction) {
      const uiState = addLifeCycleStatus({
        lifecycle_status: res.payload.transaction[0]?.lifecycle_status,
        distribution_lifecycle_status:
          res.payload.transaction[0]?.distribution_lifecycle_status,
        services,
      });
      // Single enriched object wrapped in array — same as reference
      setTimelineTxnDetails([{ ...res.payload.transaction[0], ...uiState }]);
    }

    setTimelineLoading(false);
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
    setTxnSearchType("additional");
  };

  const handleConfidentialMethod = (selectedConfidential) => {
    setIsConfidentialMethod(selectedConfidential);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };
  const handleFilterDateRange = (startDate, endDate) => {
    setStartDateFilter(startDate);
    setEndDateFilter(endDate);
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(storedPage) || currentPage);
    toggleDropdown();
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleRefresh = async (e, id, prevBalance) => {
    e.stopPropagation();
    setrefreshAnimation(id);
    setPrevBalance(prevBalance);
    try {
      let response = await dispatch(getOwnerAccBalance(id));

      if (response?.payload?.status === true) {
        let data = accumulatedData?.map((item) => {
          if (
            response?.payload.owner_accounts[0].owner_account_id ===
            item.owner_account_id
          ) {
            return {
              ...item,
              owner_account_balance_last_fetched_at_in_words:
                response.payload.owner_accounts[0]
                  .owner_account_balance_last_fetched_at_in_words,
              owner_account_balance:
                response.payload.owner_accounts[0].owner_account_balance,

              owner_account_balance_last_fetched_at:
                response.payload.owner_accounts[0]
                  .owner_account_balance_last_fetched_at,
            };
          }
          return item;
        });
        setAccumulatedData(data);
        setTimeout(() => {
          CommonToast({
            text: "Balance refreshed successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          dispatch(setshowsuccestoast());
        }, 250);
      } else {
        setTimeout(() => {
          toast.dismiss();
          const errorMessage =
            response?.payload?.response?.data?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ] ||
            response?.payload?.message ||
            "Something went wrong";

          CommonToast({
            text: errorMessage,
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, 500);
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  };
  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const getLastNDaysRange = (n = 7) => {
    const days = Number(n) || 7;
    return {
      startDate: dayjs()
        .subtract(days - 1, "day")
        .startOf("day")
        .unix(),
      endDate: dayjs().endOf("day").unix(),
    };
  };

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!currentCategory ||
        !!isPaymentMethod ||
        !!selectedBeneAccId ||
        txnAmountFilter ||
        selectedOwnerAccId ||
        isConfidentialMethod,
    );
  };

  const handleClearParams = (e) => {
    e?.stopPropagation();
    setTxnAmount("");
    setTxnAddDetails("");
    setTxnAmountFilter("");
    setTxnPayLoad((prev) => ({
      ...prev,
      amount: "",
      ownerbankAccountNo: "",
      ownerAccountId: "",
    }));
    setCurrentCategory("");
    setConfidentialMethod("");
    setIsConfidentialMethod("");
    setBeneAccountId(null);
    setSelectedBeneAccId("");
    setAccountName("");
    setSelectedOwnerAccId("");
    setIsPaymentMethod("");
    setPaymentMethod("");
    setIsConfidentialMethod("");
    setConfidentialMethod("");
    setSearchUserTextDebounce("");

    const [defaultStart, defaultEnd] = getDefaultWeekSpan();
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setStartDateFilter(Math.floor(defaultStart.getTime()));
    setEndDateFilter(Math.floor(defaultEnd.getTime()));
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Internal account":
          response = await dispatch(
            beneInternalViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.internal_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;

        case "Owner account":
          response = await dispatch(
            ownerListViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;

        case "Labels":
          data =
            labels
              ?.filter((itm) => itm.includes(searchUserTextDebounce))
              ?.map((val) => ({ id: val, Label: val })) || [];
          break;

        case "Category":
          response = await dispatch(
            beneCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.name,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Search":
          setSearchUserText(searchUserTextDebounce);
          setLoadingData(false);
          break;

        default:
          data = [];
          setLoadingData(false);
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnId);
    const res = await dispatch(
      addInternalTxnLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (addInternalTxnLabel.fulfilled.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: "Labels assigned successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalExtraLarge);
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addInternalTxnLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (addInternalTxnLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnId);
    const res = await dispatch(
      removeInternalTxnLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeInternalTxnLabel.fulfilled.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: "Labels unassigned successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalExtraLarge);
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeInternalTxnLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    if (isDashboradCheck && startDateLocationState && endDateLocationState) {
      setStartDate(new Date(startDateLocationState * 1000));
      setEndDate(new Date(endDateLocationState * 1000));
      return;
    }

    const { startDate: defaultStart, endDate: defaultEnd } =
      getLastNDaysRange(7);
    setStartDate(new Date(defaultStart * 1000));
    setEndDate(new Date(defaultEnd * 1000));
  }, [isDashboradCheck, startDateLocationState, endDateLocationState]);
  useEffect(() => {
    if (startDate === "" || endDate === "") {
      const [c, w] = getWeekSpan();
      setStartDate(c);
      setEndDate(w);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    window.addEventListener("resize", (e) => {
      if (isMobile()) closeRefactorTxnDetailModal();
    });
  }, []);

  useEffect(() => {
    if (scrollRef) {
      if (scrollRef?.current?.scrollWidth > scrollRef?.current?.clientWidth) {
        setHideCaroursal(true);
      } else {
        setHideCaroursal(false);
      }
    }
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    selectedBeneAccId,
    isPaymentMethod,
    accountNumber,
    txnAmountFilter,
    isConfidentialMethod,
  ]);

  useEffect(() => {
    handleAction();
  }, [
    markerData,
    dispatch,
    currentPage,
    pageSize,
    isPaymentMethod,
    currentStatus,
    endDateFilter,
    startDateFilter,
    txnAmount,
    txnAddDetails,
    txnAmountFilter,
    currentCategory,
    isConfidentialMethod,
    selectedBeneAccId,
    selectedOwnerAccId,
    labelsFilter,
  ]);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);
    setTotalPages(newTotalPages);

    setCurrentPage((prevPage) => {
      if (newTotalPages === 0) {
        return 1;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, 150);
    }
  }, [ownerAccBalanceLoading]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    txnAmountFilter,
    isPaymentMethod,
    selectedBeneAccId,
    selectedOwnerAccId,
    isConfidentialMethod,
  ]);

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active]);

  useEffect(() => {
    if (isLabelPopupOpen) {
      handleAction();
      let availableLabels = sessionStorage?.getItem(
        "AvailableLabelsInternalTxn",
      );
      const parsedLabels = JSON?.parse(availableLabels);
      setLabels(parsedLabels);
    }
  }, [isLabelPopupOpen]);

  return (
    <>
      {showRefactorDetailPop && !isMobile() && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-Primary-black bg-opacity-dark-opacity"
          onClick={() => {
            closeRefactorTxnDetailModal();
          }}
        >
          <InternalTxnDetailPagePopup
            setShowInternalTxnDetailPop={(x) => x}
            setErrorMessage={(x) => x}
            closeInternalTxnDetailModal={closeRefactorTxnDetailModal}
            internal_txn_id={txnId}
            type={"internal_txn_detail_modal"}
          />
        </div>
      )}
      {OpenTimeLinePopup && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-Primary-black bg-opacity-dark-opacity"
          // onClick={closeTimelineModal}
        >
          <LargePopupRedirect
            headerTitle="Transaction timeline"
            closeiconhandleFunction={() => {
              setOpenTimelinePopup(false);
              setTimelineTxnId(null);
              setTimelineTxnDetails([]);
            }}
            isscrollRequired={true}
          >
            {timelineLoading ? (
              <div className="flex justify-center items-center w-full py-padding-xl h-full">
                <Loader />
              </div>
            ) : timelineTxnDetails.length > 0 ? (
              <TimelinePopupContent
                logsData={timelineTxnDetails}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={true}
                showDistributionTimeline={true}
                openApprovalTimeline={openApprovalTimeline}
                openDistributionTimeline={openDistributionTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                setOpenDistributionTimeline={setOpenDistributionTimeline}
                handleApprovalClick={() => {}}
                cardType={"double"}
                popUpMode={true}
              />
            ) : (
              <div className="flex justify-center items-center w-full py-padding-xl">
                <p className="text-text-secondary text-font-sm">
                  No timeline data available.
                </p>
              </div>
            )}
          </LargePopupRedirect>
        </div>
      )}
      {isLabelPopupOpen && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setIsLabelPopupOpen(true);
          }}
          className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTxnId}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={accumulatedData
              ?.filter((t) => labelTxnId.includes(t.txn_id))
              ?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}

      {/* --------------------------- */}
      <div
        className={`flex flex-col items-center relative w-width-full h-full-height overflow-hidden`}
      >
        <div
          className={`bene_div_container Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act relative w-full`}
        >
          <div className="Qmd:min-h-navbar-breadcrumb-height bg-primary-nav"></div>
          <TopNavComponent
            BottomHeader="Recreate transaction dashboard"
            BottomSubText="The following transactions were rejected but their data can be used to recreate new ones."
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: allScheduleTxnAccountsLoading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search internal transaction",
              filterPlaceholder: "transaction details",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: txnAddDetails,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    handleSearch(val);
                    setTxnAddDetails(val);
                  },
                  isDropdown: false,
                  isDisabled: loading,
                },

                {
                  name: "Internal account",
                  short_name: "Int. Acc",
                  isMulti: false,
                  value: selectedBeneAccId,
                  displayValue: formatName(accountName || accountNameValue),
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setSelectedBeneAccId(val);
                  },

                  setDisplayValue: (val) => {
                    setAccountName(val);
                    setAccountNameValue(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: loading,
                },

                {
                  name: "Owner account",
                  short_name: "Own. Acc",
                  isMulti: false,
                  value: selectedOwnerAccId,
                  displayValue: standardAccountNumberFormat(
                    accountNumber,
                    true,
                  ),
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setSelectedOwnerAccId(val);
                  },
                  setDisplayValue: setAccountNumber,
                  valueType: "string",
                  isDropdown: true,
                  isDisabled: loading,
                },
                {
                  name: "Category",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentCategory(val);
                  },
                  isDropdown: true,
                  isDisabled: loading,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: labelsFilter,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setFilterLabels(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: loading,
                },
                {
                  name: "Amount",
                  short_name: "Amt - INR",
                  isMulti: false,
                  value: txnAmountFilter,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setTxnAmountFilter(val);
                  },
                  displayValue: FormatAmount({ price: txnAmountFilter }),
                  isDropdown: false,
                  isDisabled: loading,
                  valueType: "number",
                },
              ],
              filters: [
                {
                  name: "Payment method",
                  filterType: "dropdown",
                  variant: "single",
                  value: paymentMethod,
                  dropdownType: "PaymentMethod",
                  options: ["NEFT", "RTGS"],
                  dropdownPlaceHolder: "Select type",
                  isDisabled: false,
                  statusPop: true,
                  handleChange: (value) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setPaymentMethod(value);
                    handlePaymentMethod(value);
                  },
                },
                {
                  name: "Show/hide confidential transactions",
                  filterType: "dropdown",
                  variant: "single",
                  value: confidentialMethod,
                  options: ["Show only confidential", "Hide confidential"],
                  dropdownPlaceHolder: "Select type",
                  isDisabled: false,
                  statusPop: true,
                  handleChange: (value) => {
                    setCurrentPage(GlobalConfiguration?.lengthCheckOne);
                    setConfidentialMethod(value);
                    handleConfidentialMethod(value);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value:
                    (startDate && endDate) ||
                    (startDateFilter && endDateFilter),
                  isDisable: false,
                  startDate:
                    startDate ||
                    (startDateFilter
                      ? new Date(
                          startDateFilter *
                            IntervalConfiguration.intervalMedium,
                        )
                      : null),
                  endDate:
                    endDate ||
                    (endDateFilter
                      ? new Date(
                          endDateFilter * IntervalConfiguration.intervalMedium,
                        )
                      : null),
                  handleChange: (dates) => {
                    const [start, end] = dates || [];
                    if (!start && !end) {
                      const [defaultStart, defaultEnd] = getDefaultWeekSpan();

                      setStartDate(defaultStart);
                      setEndDate(defaultEnd);

                      setStartDateFilter(defaultStart.getTime());
                      setEndDateFilter(defaultEnd.getTime());

                      handleFilterDateRange(
                        defaultStart.getTime(),
                        defaultEnd.getTime(),
                      );

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      return;
                    }

                    setStartDate(start);
                    setEndDate(end);

                    if (start && end) {
                      handleFilterDateRange(
                        Math.floor(start.getTime()),
                        Math.floor(end.getTime()),
                      );
                    }
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  },
                },
              ],
              isSearchClearAllDisabled: !(
                searchUserTextDebounce?.length || loading
              ),
              isFilterClearAllDisabled: !(
                paymentMethod?.length > GlobalConfiguration?.lengthCheckZero ||
                confidentialMethod?.length >
                  GlobalConfiguration?.lengthCheckZero ||
                (startDateFilter && endDateFilter) ||
                allScheduleTxnAccountsLoading
              ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loadingData,
              setLoading: setLoadingData,
              isShowFilter: true,
            }}
          />
        </div>

        <div
          className={`flex flex-col items-center w-width-full h-height-full bg-primary-bg 
            ${accumulatedData?.length > GlobalConfiguration?.lengthCheckZero ? "mb-[var(--pagination-height)]" : ""}  ${
              showInnerSearchBar
                ? "overflow-y-hidden  cursor-pointer-none pointer-events-none"
                : "overflow-auto"
            }`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
          )}
          {allScheduleTxnAccountsLoading ? (
            <div
              className={`m-auto justify-center items-center flex ${
                showInnerSearchBar
                  ? "overflow-y-hidden cursor-pointer-none pointer-events-none"
                  : ""
              }`}
            >
              {/* {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )} */}
              <Loader />
            </div>
          ) : accumulatedData?.length > GlobalConfiguration?.lengthCheckZero ? (
            <div
              className="scroll flex flex-col w-width-full items-center justify-center"
              ref={filterRef}
            >
              {/* {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )} */}

              {/* Pagination */}
              <div className="fixed w-full bottom-bottom-base bg-primary-nav z-z-index-tooltip">
                {showInnerSearchBar && (
                  <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
                )}
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  setIsOpen={setIsOpen}
                />
              </div>

              {/* Cards */}
              <div className="scroll flex flex-col items-center justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base pb-padding-md">
                {accumulatedData
                  ?.filter(
                    (account) => account?.lifecycle_status !== "abandoned",
                  )
                  ?.map((account, index) => (
                    <div
                      key={account?.txn_id}
                      className={`beneTxn_recreate_data_card w-width-full
                    ${isSidebarOpen ? "opacity-light-opacity" : ""}
                    ${
                      index === GlobalConfiguration?.lengthCheckZero
                        ? "mt-margin-md"
                        : ""
                    }`}
                    >
                      <CommonTransactionApprovalCard
                        entries={[
                          [
                            {
                              type: "textSubtext",
                              text: `INR ${FormatAmount({
                                price: account?.amount || "0",
                              })}`,
                              subText: "Amount",
                              textColor: "var(--settled)",
                              icon: ICONS?.INTERNAL_WHITE_CIRCLE,
                              iconColor: "",
                              isBold: true,
                            },
                            {
                              type: "textSubtext",
                              text: account?.internal_account_name
                                .toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1),
                                )
                                .join(" "),
                              subText: "Account name",
                              icon:
                                account?.confidential_transaction === "Y" &&
                                ICONS?.CONFIDENTIAL_TRANSACTION,
                            },
                            {
                              type: "cta",
                              text: account?.labels?.length
                                ? account?.labels.join(", ")
                                : "No labels assigned",
                              subText: "Labels",
                              onClick: (e) => {
                                if (
                                  services?.includes("ALabel") &&
                                  services?.includes("RLabel")
                                ) {
                                  e.stopPropagation();
                                  setLabelTxnId([account?.txn_id]);
                                  setSelectedLabels(account?.labels || []);
                                  setIsLabelPopupOpen(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "ALabel,RLabel",
                                    },
                                  });
                                }
                              },
                            },
                          ],
                        ]}
                        ctaBtn1Text="Approval history"
                        ctaBtn1OnClick={(e) => {
                          if (!isSidebarOpen) {
                            e.stopPropagation();
                            openTimelineModal(account?.txn_id);
                            setTxnId(account?.txn_id);
                          }
                          // toast.info("Feature coming soon!", toast_position);
                        }}
                        ctaBtn2Text="Additional details"
                        ctaBtn2OnClick={(e) => {
                          if (!isSidebarOpen) {
                            e.stopPropagation();
                            openRefactorTxnDetailModal();
                            setTxnId(account?.txn_id);
                          }
                        }}
                        alerts={[]}
                        cardState="default"
                        thisIsARecreateCard
                        ownerAccountNumber={account?.owner_account_bank_acc_no}
                        ownerAccountIfsc={
                          account?.owner_account_ifsc_code || ""
                        }
                        ownerAccountNumberSubtext="Source account"
                        ownerAccountBalance={
                          account?.owner_account_balance ?? "Not available"
                        }
                        ownerAccountBalanceSubtext={`Balance - ${
                          account?.owner_account_balance_last_fetched_at_in_words ||
                          "Not available"
                        }`}
                        ownerAccountBalanceOnClick={(e) => {
                          handleRefresh(
                            e,
                            account?.owner_account_id,
                            account?.owner_account_balance,
                          );
                        }}
                        destinationAccountNumber={
                          account?.internal_account_bank_acc_no
                        }
                        destinationAccountIfsc={
                          account?.internal_account_ifsc_code || ""
                        }
                        destinationAccountNumberSubtext="Destination account"
                        destinationAccountText={
                          account?.internal_account_ifsc_code
                        }
                        destinationAccountSubtext="IFSC code"
                        createdOnRequired={false}
                        recreateOnClick={() => {
                          if (!services.includes("CInternalTxn")) {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "CInternalTxn",
                              },
                            });
                          } else if (!isSidebarOpen) {
                            sessionStorage.setItem(
                              "recreate_int_txn_id",
                              JSON.stringify(account?.txn_id),
                            );
                            navigate(
                              "/internal_transaction_dashboard/create_internal_transaction",
                              {
                                state: {
                                  txn_id: account?.txn_id,
                                  type: "refactorFlow",
                                },
                              },
                            );
                          }
                        }}
                        recreateBtnText="Recreate transaction"
                        recreateBtnIsDisabled={
                          !services.includes("CInternalTxn")
                        }
                      />
                    </div>
                  ))}
              </div>
            </div>
          ) : noResultsAfterFilter ? (
            <div className="w-width-full h-full flex items-center justify-center">
              <div className="flex flex-col items-center gap-gap-sm">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="w-graphic-width-md h-graphic-rectangle-height-md"
                />
                <>
                  <p className="text-text-primary text-font-sm items-center">
                    No data found.
                  </p>
                  <PrimaryButton
                    btnText="Clear parameters"
                    handleFunction={handleClearParams}
                    enabledBgColor="var(--primary-nav-act)"
                    enabledTextColor="var(--text-primary)"
                  />
                </>
              </div>
            </div>
          ) : noTransactionsFromAPI ? (
            <div className="w-width-full h-full flex items-center justify-center">
              <div className="w-width-full h-full flex items-center justify-center">
                <div className="flex flex-col items-center gap-gap-sm">
                  <img
                    src={ICONS?.NO_PENDING_TRANSACTION}
                    alt="No accounts found"
                    className="w-graphic-width-md h-graphic-rectangle-height-md"
                  />

                  <p className="text-text-primary text-font-sm pt-padding-sm items-center">
                    There are no more transactions that require recreation.
                  </p>
                  <PrimaryButton
                    btnText="Internal transaction dashboard"
                    handleFunction={() =>
                      navigate("/internal_transaction_dashboard")
                    }
                    enabledBgColor="var(--primary-act)"
                    enabledTextColor="var(--text-primary)"
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default RefactoredInternalTxnDashboard;
